export const GET_QUESTIONS_LIST="GET_QUESTIONS_LIST"
export const GET_QUESTIONS_LIST_SUCCESS="GET_QUESTIONS_LIST_SUCCESS"
export const GET_QUESTIONS_LIST_FAILED="GET_QUESTIONS_LIST_FAILED"
export const GET_WORKFLOW_LIST="GET_WORKFLOW_LIST"
export const GET_WORKFLOW_LIST_SUCCESS="GET_WORKFLOW_LIST_SUCCESS"
export const GET_WORKFLOW_LIST_FAILED="GET_WORKFLOW_LIST_FAILED"
export const ADD_NEW_QUESTION="ADD_NEW_QUESTION"
export const ADD_NEW_QUESTION_SUCCESS="ADD_NEW_QUESTION_SUCCESS"
export const ADD_NEW_QUESTION_FAILED="ADD_NEW_QUESTION_FAILED"
export const GET_QUESTION_DETAILS="GET_QUESTION_DETAILS"
export const GET_QUESTION_DETAILS_SUCCESS="GET_QUESTION_DETAILS_SUCCESS"
export const GET_QUESTION_DETAILS_FAILED="GET_QUESTION_DETAILS_FAILED"
export const UPDATE_QUESTION_DETAILS="UPDATE_QUESTION_DETAILS"
export const UPDATE_QUESTION_DETAILS_SUCCESS="UPDATE_QUESTION_DETAILS_SUCCESS"
export const UPDATE_QUESTION_DETAILS_FAILED="UPDATE_QUESTION_DETAILS_FAILED"
export const TOGGLE_QUESTION="TOGGLE_QUESTION"
export const TOGGLE_QUESTION_SUCCESS="TOGGLE_QUESTION_SUCCESS"
export const TOGGLE_QUESTION_FAILED="TOGGLE_QUESTION_FAILED"
export const GET_WORKFLOW_OPTIONS_LIST="GET_WORKFLOW_OPTIONS_LIST"
export const GET_WORKFLOW_OPTIONS_LIST_SUCCESS="GET_WORKFLOW_OPTIONS_LIST_SUCCESS"
export const GET_WORKFLOW_OPTIONS_LIST_FAILED="GET_WORKFLOW_OPTIONS_LIST_FAILED"
export const ADD_NEW_WORKFLOW="ADD_NEW_WORKFLOW"
export const ADD_NEW_WORKFLOW_SUCCESS="ADD_NEW_WORKFLOW_SUCCESS"
export const ADD_NEW_WORKFLOW_FAILED="ADD_NEW_WORKFLOW_FAILED"
export const UPDATE_WORKFLOW_DETAILS="UPDATE_WORKFLOW_DETAILS"
export const UPDATE_WORKFLOW_DETAILS_SUCCESS="UPDATE_WORKFLOW_DETAILS_SUCCESS"
export const UPDATE_WORKFLOW_DETAILS_FAILED="UPDATE_WORKFLOW_DETAILS_FAILED"
export const GET_SAMPLE_CSV_QUESTION="GET_SAMPLE_CSV_QUESTION"
export const GET_SAMPLE_CSV_QUESTION_SUCCESS="GET_SAMPLE_CSV_QUESTION_SUCCESS"
export const GET_SAMPLE_CSV_QUESTION_FAILED="GET_SAMPLE_CSV_QUESTION_FAILED"
export const GET_CSV_QUESTION_STATUS="GET_CSV_QUESTION_STATUS"
export const GET_CSV_QUESTION_STATUS_SUCCESS="GET_CSV_QUESTION_STATUS_SUCCESS"
export const GET_CSV_QUESTION_STATUS_FAILED="GET_CSV_QUESTION_STATUS_FAILED"
export const BULK_IMPORT_QUESTIONS="BULK_IMPORT_QUESTIONS"
export const BULK_IMPORT_QUESTIONS_SUCCESS="BULK_IMPORT_QUESTIONS_SUCCESS"
export const BULK_IMPORT_QUESTIONS_FAILED="BULK_IMPORT_QUESTIONS_FAILED"
export const DELETE_WORKFLOW="DELETE_WORKFLOW"
export const DELETE_WORKFLOW_SUCCESS="DELETE_WORKFLOW_SUCCESS"
export const DELETE_WORKFLOW_FAILED="DELETE_WORKFLOW_FAILED"



